import { authenticated, authenticated_cached } from './WebRequest';
import { omitNil } from '../mylib/Utils';
import type {
  ApiThunk,
  ClientVersions,
  ConfigurationMap,
  JsonValue,
  LabelTemplate,
  MatchsettingNamesParameters,
  Nullable,
  Site,
  SiteUpdateResponse,
  Systemgroup,
} from './types/Configuration';

export type {
  ApiThunk,
  ClientVersions,
  ConfigurationMap,
  ConfigurationValue,
  JsonPrimitive,
  JsonValue,
  LabelTemplate,
  MatchsettingNamesParameters,
  Nullable,
  Site,
  SiteUpdateResponse,
  Systemgroup,
} from './types/Configuration';

// endpoint root

export default class ConfigurationsAPI {
  static loadConfigurations(
    zoneid: number,
    siteid: number
  ): ApiThunk<ConfigurationMap> {
    return authenticated.get<ConfigurationMap>(
      `/query/zone/${zoneid}/site/${siteid}/configuration_v2`
    );
  }

  static loadPrintLabels(
    zoneid: number,
    siteid: number
  ): ApiThunk<LabelTemplate[]> {
    return authenticated.get<LabelTemplate[]>(
      `/query/zone/${zoneid}/site/${siteid}/labels_list`
    );
  }
  static savePrintLabels(
    siteid: number,
    labels: LabelTemplate[]
  ): ApiThunk<LabelTemplate[]> {
    return authenticated.post<LabelTemplate[]>(
      `/query/site/${siteid}/set_site_labels_list`,
      {
        value: labels,
      }
    );
  }

  static loadEmailTemplates(
    zoneid: number,
    siteid: number
  ): ApiThunk<LabelTemplate[]> {
    return authenticated.get<LabelTemplate[]>(
      `/email/zone/${zoneid}/site/${siteid}/email_template_list`
    );
  }

  static saveEmailTemplates(
    siteid: number,
    labels: LabelTemplate[]
  ): ApiThunk<LabelTemplate[]> {
    return authenticated.post<LabelTemplate[]>(
      `/email/site/${siteid}/set_email_template_list`,
      {
        value: labels,
      }
    );
  }

  static matchsettingNames(
    parameters: MatchsettingNamesParameters
  ): ApiThunk<string[]> {
    const { zoneid } = omitNil(parameters);
    return authenticated_cached.get<string[]>(
      `/matching/matchsetting_names/zone/${zoneid}`
    );
  }

  static loadSite(
    clientname?: Nullable<string>,
    versions?: Nullable<ClientVersions>
  ): ApiThunk<Site> {
    return authenticated.post<Site>('/auth/site/v2/', {
      clientname,
      versions,
    });
  }

  static updateSite(site: Site): ApiThunk<SiteUpdateResponse> {
    return authenticated.post<SiteUpdateResponse>('/auth/update_site', site);
  }

  static getSystemgroup(): ApiThunk<Systemgroup[]> {
    return authenticated.get<Systemgroup[]>('/rest/systemgroup/');
  }

  static setSiteConfiguration(
    zoneid: number,
    siteid: number,
    key: string,
    value: JsonValue
  ): ApiThunk<null> {
    return authenticated.post<null>(
      `/query/zone/${zoneid}/site/${siteid}/set_configuration_v2`,
      { key, value }
    );
  }
  static unsetSiteConfiguration(
    zoneid: number,
    siteid: number,
    key: string
  ): ApiThunk<null> {
    return authenticated.post<null>(
      `/query/zone/${zoneid}/site/${siteid}/unset_configuration_v2`,
      { key }
    );
  }
}
